import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { ConfirmationService } from 'primeng/api';
import { ChildEvent, ScrBaseComponent } from 'src/app/components/base.component';
import { Partner } from 'src/app/models/partner.model';
import { ConfigService } from 'src/app/services/config.service';
import { PartnerService } from 'src/app/services/partner.service';
import { NgForm } from '@angular/forms';
import { ChipsAddEvent } from 'primeng/chips';
import { PartnerType } from '../../../../models/constants';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Component({
  selector: 'app-update-partner',
  templateUrl: './update-partner.component.html',
  styleUrls: ['./update-partner.component.scss']
})
export class UpdatePartnerComponent extends ScrBaseComponent implements OnInit {

  @Input() partner!: Partner;
  @Input() public partnerType = PartnerType.Brand;
  public partnerTypeWithSpace = 'Brand';
  public partnerTypeShort = 'Brand';

  @Input() public scIdCount? = 0;

  @Output() emitAction = new EventEmitter<ChildEvent>();

  @ViewChild('form1', { static: false }) form1!: NgForm;

  public model = new Partner();
  public legalEntityTypes: string[] = [];
  public allScIds: number[] | undefined;
  public publicEmailDomains: string[] = [];
  submitted = false;
  public isDisplay = false;
  vettingRequiredFields: string[] = [];
  

  constructor(private configService: ConfigService,
    private confirmService: ConfirmationService,
    private brandService: PartnerService) {
    super();
  }

  ngOnInit(): void {

    if (this.partnerType === PartnerType.Brand) {
      this.partnerTypeWithSpace = 'Brand Client';
      this.partnerTypeShort = 'Brand';
    }
    else {
      this.partnerTypeWithSpace = 'Content Provider';
      this.partnerTypeShort = 'Content Provider';
    }



    this.configService.getConfig().subscribe(cfg => {

      this.legalEntityTypes = cfg.legalEntityTypes
      this.publicEmailDomains = cfg.excludedPublicEmailDomains;
      const vettingFileds = cfg.vetting?.revet?.find(r => r.entityType === this.partnerType);
      this.vettingRequiredFields = vettingFileds?.fields ?? ['fein', 'company'];
    });

    this.updateModelFromPartner(this.partner);
    this.isDisplay = true;
    window.scroll(0, 0);

  }


  updateModelFromPartner(brand: Partner): void {
    this.allScIds = this.partner.scIds;

    this.model = Object.assign({}, brand);
    // keep the original for the radio button display.
    const subsidiaries = this.partner?.subsidiaries as unknown as string;
    if (!this.model.country)
      this.model.country = 'us';

    this.model.partnerId = this.partner.partnerId;
    this.model.subsidiaries = subsidiaries?.split('^');
  }


  updatePartner({ form }: NgForm) {

    this.submitted = true;

    // the p-checkbox doesn't get marked as dirty if user skips by.
    // if we mark it dirty here, it doesn't matter.  it is either checked or not.

    this.clearMessages();
    form.markAllAsTouched();
    for (const name in form.controls) {
      form.controls[name].markAsDirty();
    }

    if (form.invalid) {
      this.submitted = true;
      this.scrollToFirstError();
    } else {

      const prunedData = this.removeEmpty(form.value);
      prunedData.partnerId = this.partner.partnerId;
      const formData = JSON.parse(JSON.stringify(prunedData, this.prepareForSubmit));
      formData.subsidiaries = formData.subsidiaries?.join('^') || null;
      formData.legalEntityType = formData.legalEntityType?.name || this.model.legalEntityType;
      if (this.getChangedFields(this.partner, formData)) {
        formData['annualRevetInprogress'] = false;
      }

      this.observe(this.brandService.savePartner(formData), res => {
        if (res.messages && res.messages.length > 0) {
          this.emitAction.emit({ action: 'reload', value: 'reload', message: res.messages[0].message });
        }
        else {
          this.emitAction.emit({ action: 'reload', value: 'reload', messageCode: 'scr.cc.updated' });
        }
        return false;
      });
    }
  }
  removeEmpty(obj: Record<string,unknown> | ArrayLike<unknown>) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != ''));
  }

  getChangedFields(originalObj: Partner, modifiedObj: Partner) {
    const changedFields: string[] = [];
  
    for (const key in modifiedObj) {
      if (originalObj[key as keyof typeof originalObj] !== modifiedObj[key as keyof typeof modifiedObj]) {
        changedFields.push(key);
      }
    }
    return this.vettingRequiredFields.some(element => changedFields.includes(element));
  }

  onChangeDropdown(event: DropdownChangeEvent) {
    if (!event.value)
      this.model.legalEntityType = undefined;
  }

  prepareForSubmit(key: string, value: string | number | boolean) {
    if (typeof value === 'string')
      return value.trim();

    return value;
  }

  confirmCancelDialog() {
    this.confirmService.confirm({
      key: 'confirmCancel',
      header: 'Confirm Cancellation',
      message: 'Are you sure you want to cancel the request?',
      accept: () => {
        this.form1.reset();
        this.emitAction.emit({ action: 'cancel', value: 'reload' });
        this.submitted = false;
      },
      reject: () => {
        this.confirmService.close();
      }
    });
  }

  handleEnter(event: Event) {
    handleEnterKeyPress(event);
  }

  validateChipFormat(event: ChipsAddEvent) {
    if (event.value.includes('^')) {
      this.model.subsidiaries?.pop();
    }
  }
}
